import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import PublicShell from './components/start/PublicShell';
import { lightTheme } from './theme';
import Layout from './components/Layout/Layout';
import SiteFooter from './components/Layout/SiteFooter';
import Login from './pages/auth/login/Login';
import Register from './pages/auth/register/Register';
import LoadingSpinner from './components/common/LoadingSpinner';
import { useAuth } from './hooks/auth/useAuth';
import './App.css';
// 실시간 서비스 초기화
import './services/realtimeService';
import Lecture from './pages/main/lecture/Lecture';
import LectureDetail from './pages/main/lecture/LectureDetail';
import Note from './pages/main/note/Note';
import Report from './pages/main/report/Report';
import ExamList from './pages/main/exams/ExamList';
import Practice from './pages/main/practice/Practice';
import Intro from './pages/start/Intro';
import PaymentManagement from './pages/main/payment/PaymentManagement';
import PaymentSuccess from './pages/main/payment/PaymentSuccess';
import PaymentFail from './pages/main/payment/PaymentFail';

// 보호된 라우트 컴포넌트
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) {
    return <LoadingSpinner message="인증 확인 중..." />;
  }
  return isAuthenticated ? children : <Navigate to="/" replace />;
};

// 공개 라우트 (로그인된 사용자는 강의실로 이동)
const PublicRoute = () => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) {
    return <LoadingSpinner message="인증 확인 중..." />;
  }
  return isAuthenticated ? <Navigate to="/lecture" replace /> : <PublicShell />;
};

const AppRoot = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f8f5ee;
`;

const AppMain = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;

function App() {
  return (
    <ThemeProvider theme={lightTheme}>
      <Router>
        <AppRoot className="App">
          <AppMain>
            <Routes>
              <Route element={<PublicRoute />}>
                <Route path="/" element={<Intro />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
              </Route>
              <Route
                path="/lecture"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Lecture />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/lecture/:id"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <LectureDetail />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/report"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Report />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/exams"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <ExamList />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/practice"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Practice />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/note"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Note />
                    </Layout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/payment"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Outlet />
                    </Layout>
                  </ProtectedRoute>
                }
              >
                <Route index element={<PaymentManagement />} />
                <Route path="success" element={<PaymentSuccess />} />
                <Route path="fail" element={<PaymentFail />} />
              </Route>
            </Routes>
          </AppMain>
          <SiteFooter />
        </AppRoot>
      </Router>
    </ThemeProvider>
  );
}

export default App;
